import type { ContractInput } from '@timelog/pm-shared';

/**
 * The task contract dropdown (design v8, Area 5 / ADR 0033): a task is mapped
 * to a contract only by its own explicit choice. The first option is "No
 * contract" — the task's hours count and nothing is priced (D7) — followed by
 * one entry per contract the project's Financials hold, in Financials order,
 * labelled with the CONTRACT'S NAME; the billing method is the chip beside it,
 * never the label (a project with two fixed-price contracts must tell them
 * apart at a glance). There is no "Project default": the project's default
 * contract is only what new tasks are prefilled with, never what an unmapped
 * task resolves to (D8).
 */

export type ContractOption = {
  kind: 'none' | 'contract';
  /** undefined for 'none' — picking it clears the task's contractId. */
  contractId: string | undefined;
  /** The billing method, for the chip; undefined for 'none'. */
  type: ContractInput['type'] | undefined;
  label: string;
};

/** The English default; UI callers pass the translated `pmPlanning:contract.NoContract`. */
export const NO_CONTRACT_LABEL = 'No contract';

export const contractOptions = (
  contracts: readonly ContractInput[],
  noContractLabel: string = NO_CONTRACT_LABEL,
): ContractOption[] =>
  contracts.length === 0
    ? []
    : [
        { kind: 'none', contractId: undefined, type: undefined, label: noContractLabel },
        ...contracts.map((contract): ContractOption => ({
          kind: 'contract',
          contractId: contract.id,
          type: contract.type,
          label: contract.name,
        })),
      ];
